import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import "./assets/scss/styles.scss";
import router from "./router";
import { useMainStore } from "./stores/store";
import vuetify from "@/plugins/vuetify";

/************************************************
 * Toast
 ************************************************/
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const pinia = createPinia();

// setupInterceptors();

const app = createApp(App)
  .use(router)
  .use(pinia)
  .use(useMainStore())
  .use(vuetify)


app.config.globalProperties.$toast = toast;
app.mount("#app");

router.afterEach(() => { if (window.vlmPageView) window.vlmPageView(); });
